import React from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import { FaTrophy } from "react-icons/fa";
import { GiTrophyCup } from "react-icons/gi";

interface PrizeDescriptionCardProps {
	winningPrize: string;
	losingPrize: string;
}

const PrizeDescriptionCard: React.FC<PrizeDescriptionCardProps> = ({
	winningPrize,
	losingPrize,
}) => {
	return (
		<Card
			className="h-100"
			bg="transparent"
			border="0"
			style={{ maxWidth: "20rem" }}
		>
			<Card.Body className="d-flex flex-column text-center">
				{winningPrize && (
					<div className="mb-3">
						<Button
							variant="light"
							className="rounded-pill fw-bold align-items-center py-0"
							style={{ width: "fit-content" }}
						>
							<FaTrophy className="me-2 mb-1" size={15} />
							WINNING PRIZE
						</Button>
						<Card.Text className="flex-grow-1 text-light text-center my-1 py-1 fw-bold">
							{winningPrize.toUpperCase()}
						</Card.Text>
					</div>
				)}

				{losingPrize && (
					<div>
						<Button
							variant="outline-light"
							className="mb-1 rounded-pill fw-bold align-items-center py-0"
							style={{ width: "fit-content" }}
						>
							<GiTrophyCup className="me-2 mb-1" size={15} />
							LOSING PRIZE
						</Button>
						<Card.Text className="flex-grow-1 text-light text-center my-1 py-1 fw-bold">
							{losingPrize.toUpperCase()}
						</Card.Text>
					</div>
				)}
			</Card.Body>
		</Card>
	);
};

export default PrizeDescriptionCard;
